import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns user from userProfile state
 * @return {object}
 */
export default function useUser() {
    return useAppSelector((state) => state?.userProfile.user)
}